export const CONTROLS = {
  PAN: 'PAN',
  PEN: 'PEN',
  POLYGON: 'POLYGON',
  ERASER: 'ERASER',
} as const;
